<template>
	<Modal title="Register Association as a Party" modal-width="half-width">
		<div>
			<div class="alert alert-warning mt-2" style="text-align: left">
				<strong>
					Note: This decision represents the final verdict of the Commission
					following the completion of the verification process.<br />
					Approval at this stage confirms that the association has been
					officially registered as a political party.
				</strong>
			</div>

			<div style="text-align: left">
				<div>
					<div class="form-group">
						<label for="approvalComment" class="font-weight-bold">
							<i class="fas fa-comment me-2"></i>Remarks (Optional)
						</label>
						<textarea
							class="form-control"
							id="approvalComment"
							rows="3"
							v-model="comment"
							placeholder="Any additional remarks for the registration..."
						></textarea>
					</div>

					<div class="form-group">
						<label for="approvalDocument" class="font-weight-bold">
							<i class="fas fa-file-upload me-2"></i>Approval Document or
							Certificate (Required) <br />
							<small class="text-muted">Supported format: PDF</small>
						</label>
						<div class="custom-file">
							<input
								type="file"
								class="custom-file-input form-control"
								id="approvalDocument"
								@change="handleFileUpload"
								accept=".pdf"
								required
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="modal-footer">
				<button
					type="button"
					class="btn btn-outline-secondary"
					@click="hideModal"
					:disabled="isLoading"
				>
					<i class="fas fa-times me-2"></i>Cancel
				</button>
				<button
					type="button"
					class="btn btn-info"
					@click.prevent="submitAction"
					:disabled="isLoading"
				>
					<i class="fas fa-check me-2"></i>
					<span v-if="isLoading">Please wait...</span>
					<span v-else>Register Party</span>
				</button>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { EventBus } from "@/utils/event_bus.js";
import Swal from "sweetalert2";

export default {
	components: {
		Modal,
	},
	data() {
		return {
			action: "approve",
			section: "registration_approval",
			comment: "",
			isLoading: false,
			isError: false,
			documentFile: null,
		};
	},
	methods: {
		setAction(action) {
			this.comment = "";
			this.action = action;
			this.isError = false;
		},

		submitAction() {
			if (this.action == "rejected" && this.comment == null) {
				return Swal.fire({
					text: "Remark must be provided while rejecting application",
					icon: "error",
				});
			}

			let status = this.action == "approve" ? "approved" : "rejected";
			let fd = new FormData();
			fd.append("partyID", this.$route.params.id);
			fd.append("section", this.section);
			fd.append("comment", this.comment);
			fd.append("approval_file", this.documentFile);
			fd.append("status", status);

			this.hideModal();
			this.isLoading = true;
			this.isError = false;

			Swal.fire({
				title:
					"Are you sure you want to register association as a political party?",
				text: "This is the final action and can never be undone, please ensure this is the management decision.",
				icon: "question",
				showCancelButton: true,
				confirmButtonColor: "#29623c",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes, proceed!",
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.showModal();
					this.$store
						.dispatch("parties/approveApplicationSection", fd)
						.then((resp) => {
							if (resp.status_code === 200) {
								this.comment = null;
								Swal.fire({
									icon: "success",
									title: "Congratulations!",
									text: "Association has been registered as a political party in Nigeria",
								});
							} else {
								Swal.fire({
									icon: "error",
									title: "Error",
									text:
										resp.response.data.errors.message ??
										"Unable to complete action",
								});
							}
							this.isLoading = false;
							this.hideModal();
						})
						.catch(() => {
							this.isLoading = false;
							this.isError = true;
						});
				} else {
					this.isLoading = false;
					this.showModal();
				}
			});
		},

		showModal() {
			EventBus.$emit("toggle-modal", "show");
		},

		hideModal() {
			EventBus.$emit("toggle-modal", "hide");
		},
		handleFileUpload(event) {
			this.documentFile = event.target.files[0];
		},
		resetForm() {
			this.comment = "";
			this.documentFile = null;
			this.action = "approve";
		},
	},
};
</script>

<style scoped>
.modal-header {
	border-radius: 0;
	padding: 2px 20px;
}

.modal-title {
	font-weight: 600;
}

.action-tabs .nav-link {
	cursor: pointer;
	transition: all 0.3s;
	border-radius: 0.25rem;
}

.action-tabs .nav-link.active {
	background-color: #2c3e50;
	color: white;
}

.action-tabs .nav-link:not(.active) {
	background-color: #f8f9fa;
	color: #495057;
}

.action-tabs .nav-link:not(.active):hover {
	background-color: #e9ecef;
}

.custom-file-label::after {
	content: "Browse";
}

.btn-info {
	background-color: #29623c;
	border-color: #29623c;
}

.btn-danger {
	background-color: #dc3545;
	border-color: #dc3545;
}

.form-control,
.custom-file-input {
	border-radius: 0.25rem;
	padding: 10px;
}

textarea.form-control {
	min-height: 100px;
}
</style>
